module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/master/master-view-resumenes-preventive/master-view-resumenes-preventive.component.scss
// module id = ./src/app/master/master-view-resumenes-preventive/master-view-resumenes-preventive.component.scss
// module chunks = main